import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { namespaceState,selectedModelState,lineageDiffState } from '../../recoil/atoms';
import styles from './style.module.css';
import useApi from '../../services/useApi';
import ModelDirectory from './ModelDirectory';
import Header from './Header';
import ModelInfo from './ModelInfo';
import ModelChart from './ModelChart';

export default function ModelDetail(){
    const [nsState,setNsState]=useRecoilState(namespaceState);
    const [selectedModel, setSelectedModel]=useRecoilState(selectedModelState);
    const [lineageDiff, ]=useRecoilState(lineageDiffState);
    const userId=JSON.parse(localStorage.getItem("account")).id;
    const [isLineage,setIsLineage]=useState(false);
    const [lineageDetailModel, setLineageDetailModel]=useState({});

    const handleModelChange=(modelId)=>{
        useApi.get('/ngp/modelreg/mm/model/v1/model?modelId='+modelId+'&namespaceId='+nsState.id+'&userId='+userId)
        .then((res) => {
            setSelectedModel(res.data);
        }).catch(err=>{
            alert("Model Data가 없습니다.\n삭제 혹은 잘 못된 Model ID인지 확인해주세요.")
        })
    }

    const handleLineageDetailChange=(model) => {
        setLineageDetailModel(model);
    }

    return(
        <div className={styles['wrap']}>
            <div className={styles['header']}>
                <p className={styles['title']}>
                    <span>Model Catalog</span>
                    <span>&gt;</span>
                    <span>Model Detail</span>
                </p>
            </div>
            <div className={styles['body']}>
                <ModelDirectory
                className={styles['model-directory']}
                onChange={handleModelChange}
                />
                <div className={styles['model-info']}>
                    <Header
                    className={styles['info-header']}
                    onClickLineage={()=>setIsLineage(!isLineage)}
                    isLineage={isLineage}
                    />
                    <div className={styles['main']}>
                        <ModelInfo 
                        className={`${styles['info-left']} ${isLineage&&styles['fade-out']}`}
                        model={selectedModel}
                        editable={true}
                        onChange={()=>handleModelChange(selectedModel.modelId)}/>
                        <ModelChart 
                        className={`${styles['chart']} ${isLineage&&styles['slide']}`}
                        isLineage={isLineage}
                        onLineageChange={handleLineageDetailChange}/>
                        <ModelInfo 
                        className={`${styles['info-right']} ${isLineage&&styles['fade-in']}`} 
                        model={lineageDetailModel}
                        mode='lineage'
                        diff={lineageDiff}/>
                    </div>
                </div>
            </div>
        </div>
    )
}